<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
    Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">

    <v-nav-menu
      :navMenuItems = "menus"
      title         = "Decababes"
      parent        = ".layout--main" />

    <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
      <div id="content-overlay" />

    <!-- Navbar -->
    <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
      <the-navbar-horizontal
        :navbarType= "navbarType"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />

      <div style="height: 62px" v-if="navbarType === 'static'"></div>

      <h-nav-menu
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]"
        :navMenuItems="navMenuItems" />
    </template>

    <template v-else>
      <the-navbar-vertical
        :navbarColor="navbarColor"
        :class="[
          {'text-white' : isNavbarDark  && !isThemeDark},
          {'text-base'  : !isNavbarDark && isThemeDark}
        ]" />
    </template>
    <!-- /Navbar -->

      <div class="content-wrapper">

        <div class="router-view">
          <div class="router-content">

            <transition :name="routerTransition">

              <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                <div
                  class="content-area__heading"
                  :class="{'pr-4 border-0 border-solid border-grey-light' : $route.meta.breadcrumb}">
                  <h2 class="mb-1">{{ routeTitle }}</h2>
                </div>
                <vs-spacer />
                <!-- BREADCRUMB -->
                <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

              </div>
            </transition>

            <div class="content-area__content">

              <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
              </back-to-top>

              <transition :name="routerTransition" mode="out-in">
                <router-view :key="$route.path" @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
                <b-card-footer :class="footerClasses" v-if="$slots.footer">
                  <slot name="footer"></slot>
                </b-card-footer>
              </transition>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from "@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue"
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import Pusher from 'pusher-js'
import { mapState } from 'vuex'

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu
  },
  data() {
    return {
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
    }
  },
  watch: {
    "$route"() {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark(val) {
      const color = this.navbarColor == "#fff" && val ? "#10163a" : "#fff"
      this.updateNavbarColor(color)
    },
    "$store.state.mainLayoutType"(val) {
      this.setNavMenuVisibility(val)
    }
  },
  computed: {
    ...mapState(['channels', 'activeChat', 'activeTypeChat', 'notification', 'AppActiveUser', 'differentTypeChat']),
    bodyOverlay() { return this.$store.state.bodyOverlay },
    contentAreaClass() {
      if(this.mainLayoutType === "vertical") {
        if      (this.verticalNavMenuWidth == "default") return "content-area-reduced"
        else if (this.verticalNavMenuWidth == "reduced") return "content-area-lg"
        else return "content-area-full"
      }
      // else if(this.mainLayoutType === "boxed") return "content-area-reduced"
      else return "content-area-full"
    },
    footerClasses() {
      return {
        'footer-hidden': this.footerType == 'hidden',
        'footer-sticky': this.footerType == 'sticky',
        'footer-static': this.footerType == 'static',
      }
    },
    isAppPage() {
      return this.$route.meta.no_scroll
    },
    isThemeDark()     { return this.$store.state.theme == 'dark' },
    layoutTypeClass() { return `main-${this.mainLayoutType}` },
    mainLayoutType()  { return this.$store.state.mainLayoutType  },
    menus()           { return this.$store.state.menus  },
    navbarClasses()   {
      return {
        'navbar-hidden'   : this.navbarType == 'hidden',
        'navbar-sticky'   : this.navbarType == 'sticky',
        'navbar-static'   : this.navbarType == 'static',
        'navbar-floating' : this.navbarType == 'floating',
      }
    },
    verticalNavMenuWidth() { return this.$store.state.verticalNavMenuWidth },
    windowWidth()          { return this.$store.state.windowWidth }
  },
  methods: {
    changeRouteTitle(title) {
      this.routeTitle = title
    },
    updateNavbar(val) {
      if (val == "static") this.updateNavbarColor(this.isThemeDark ? "#10163a" : "#fff")
      this.navbarType = val
    },
    updateNavbarColor(val) {
      this.navbarColor = val
      if (val == "#fff") this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    updateFooter(val) {
      this.footerType = val
    },
    setNavMenuVisibility(layoutType) {
      if((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === "vertical" && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      }
      else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    },
    toggleHideScrollToTop(val) {
      this.hideScrollToTop = val
    },
    subscribe() {
      let pusher = new Pusher(process.env.VUE_APP_KEY_PUSHER, { cluster: 'ap1', channelAuthorization: 
        { 
          endpoint: `${process.env.VUE_APP_API}me/pusher/auth`,
          headers: { "Authorization": "Bearer " + localStorage.getItem('token') }
        }
      })
      pusher.subscribe(`private-admin`)
      this.binding(pusher)
    },
    binding(pusher) {
      pusher.bind('NOTIFICATION_RECEIVED', notification => {
        const notifications = this.notification.rows
        let counter = this.notification.counter
        this.$store.commit('set_notification', {
          rows: [notification, ...notifications],
          counter: counter + 1
        })
      })
      pusher.bind('CHANNEL_CREATED', channel => {
        if((this.activeTypeChat == channel.type) || (channel.official && this.activeTypeChat === 'admin')) {
          this.$axios.get(`channels/${channel.id}`)
            .then(res => {
              this.getDetailMessage(channel)
              if((channel.type === 'personal' && this.activeTypeChat === 'admin') || (channel.type === 'group' && this.activeTypeChat === 'group')) {
                if(!this.differentTypeChat) {
                  const channels = [res.data.data, ...this.channels]
                  this.$store.commit('UPDATE_LIST_CHANNELS', channels)
                }
              }
            })
        }
      })
      pusher.bind('MESSAGE_RECEIVED', msg => {
        const dplctChannels = JSON.parse(JSON.stringify(this.channels))
        let channels = dplctChannels
        if(msg.type) {
          let channelIdx = dplctChannels.findIndex(channel => channel.name === msg.name)
          this.getDetailMessage(msg)
          channels[channelIdx].unread = 0
        } else {
          let channelIdx = dplctChannels.findIndex(channel => channel.name === msg.channelName)
          if(this.activeChat && (this.activeChat.channelName === msg.channelName  && msg.accountId !== this.AppActiveUser.admin.accountId)) {
            const activeChat = {
              ...this.activeChat,
              messages: [
                ...this.activeChat.messages,
                msg
              ]
            }
            this.$store.commit('UPDATE_ACTIVE_CHAT', activeChat)
          }

          if(msg.accountId !== this.AppActiveUser.admin.accountId){
            channels[channelIdx].unread++
          }

          if(channels[channelIdx]) {
            channels[channelIdx].lastMessage = msg.message || msg.lastMessage
          }
        }
        this.$store.commit('UPDATE_LIST_CHANNELS', channels)
      })
    },

    getDetailMessage(channel) { 
      const getDetailChannel = this.$axios.get(`channels/${channel.id}`)
      const getDetailMessage = this.$axios.get(`channels/${channel.id}/messages`)

      Promise.all([getDetailChannel, getDetailMessage]).then(res => {
        const detailChannel = res[0].data.data
        const messages = res[1].data.data
        const payload = {
          channelId: channel.id,
          fullName: detailChannel.fullName,
          avatar: detailChannel.avatar,
          channelName: detailChannel.name,
          participants: detailChannel.participants,
          temp_participants: detailChannel.participants,
          messages
        }
        this.$store.commit('UPDATE_ACTIVE_CHAT', payload)
      })
    }
  },
  created() {
    const color = this.navbarColor == "#fff" && this.isThemeDark ? "#10163a" : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    this.subscribe()
  }
}

</script>

